import React from 'react';
import Icon from 'components/AppIcon';

const BulkActions = ({ selectedCount, onBulkAction }) => {
  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center">
          <Icon name="CheckCircle" size={20} className="text-green-600 mr-2" />
          <span className="text-sm font-medium text-green-800">
            {selectedCount} client{selectedCount > 1 ? 's' : ''} selected
          </span>
        </div>
        
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => onBulkAction('notify')}
            className="inline-flex items-center px-3 py-2 text-sm font-medium text-green-700 bg-green-100 rounded-lg hover:bg-green-200 transition-colors duration-200"
          >
            <Icon name="Bell" size={16} className="mr-1" />
            Send Notification
          </button>
          
          <button
            onClick={() => onBulkAction('export')}
            className="inline-flex items-center px-3 py-2 text-sm font-medium text-blue-700 bg-blue-100 rounded-lg hover:bg-blue-200 transition-colors duration-200"
          >
            <Icon name="Download" size={16} className="mr-1" />
            Export
          </button>
          
          <button
            onClick={() => onBulkAction('delete')}
            className="inline-flex items-center px-3 py-2 text-sm font-medium text-red-700 bg-red-100 rounded-lg hover:bg-red-200 transition-colors duration-200"
          >
            <Icon name="Trash2" size={16} className="mr-1" />
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;